import Menu from 'antd/es/menu'

export default Menu
